import Overview from './overview.vue';
import MobOverview from './mob-overview.vue';
import MobFullIndex from './mob-full.vue'
import FullIndex from './full.vue'
export const componentMap = {
    overview: Overview,
    full: FullIndex,
    'mob-overview': MobOverview,
    'mob-full': MobFullIndex
};